import {
  GroupedResultFathom,
  GroupRowType,
  GroupTableFathom,
  LayerGroupType,
  LocationItem
} from "helpers/models";
import getColor from "report/common/color-rule";

export default (
  groupedResultFathom: GroupedResultFathom,
  locationItems: LocationItem[],
  legend: LayerGroupType,
  aggregationUnits: string[]
): GroupTableFathom => {
  const locationMap = Object.fromEntries(
    locationItems.map((item: LocationItem) => [item.id.replaceAll('-', ''), item])
  );

  const summary: GroupTableFathom = {};

  // 1. Traverse Layer (e.g., FL_Coastal_Global_Fathom)
  Object.entries(groupedResultFathom).forEach(([layerId, statuses]) => {
    summary[layerId] = { defended: [], undefended: [] };

    // 2. Traverse Status (defended / undefended)
    Object.entries(statuses).forEach(([statusKey, labels]) => {
      // 3. Traverse Labels (e.g., Outside, 100 years)
      Object.entries(labels).forEach(([label, items]) => {
        const row: GroupRowType = {
          label: label,
          count: items.length,
          // You can add more logic here, like color mapping
          color: getColor(label, legend[layerId])
        };

        aggregationUnits
          .filter((e) => e !== "numberOfLocations")
          .forEach((e) => {
            const sum = items.reduce((acc, i) => {
              if (i.pointId) {
                const locationItem = locationMap[i.pointId.replaceAll('-', '')];
                if (!locationItem) {
                  return 0;
                }
                const agg = locationItem[e as keyof LocationItem];
                if (typeof agg === "number") {
                  return acc + agg;
                }
              }
              return acc;
            }, 0);

            if (sum > 0) {
              (row as any)[e as keyof GroupRowType] = sum;
            }
          });

        if (statusKey === "defended" || statusKey === "undefended") {
          // Push a clean object for your UI/Chart
          summary[layerId][statusKey].push(row);
        }
      });
    });
  });

  return summary;
};
